export function getPreviouslyVisited(): string[] {
  if (typeof window === 'undefined') {
    return [];
  }
  const audiModelTrackerRaw = localStorage.getItem('audiModelTracker');
  if (audiModelTrackerRaw) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const audiModelTracker = JSON.parse(audiModelTrackerRaw);
    const { allUrls } = audiModelTracker as unknown as Record<string, unknown>;
    return allUrls as string[];
  }
  return [];
}
